import {RootState} from "../../store/reducer/root/RootState";
import {connect} from "react-redux";
import AssetCategory from "../../model/asset/AssetCategory";
import * as React from "react";
import SelectComponent from "../ui/select/SelectComponent";
import {Option} from "ts-option";


class SelectAssetCategory extends SelectComponent<AssetCategory> {
	matchFilter(element: AssetCategory, filter: string): boolean {
		return element.searchString.indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: AssetCategory): string {
		return element.id;
	}

	elementToString(element: AssetCategory) {
		return element.name;
	}

	getDropdownList(): Option<AssetCategory[]> {
		return this.props.items.map(tab => tab.filter(ac => !ac.disabled));
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.assetCategory.assetCategories
	}
}

export default connect(mapStateToProps)(SelectAssetCategory)